module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/baseballglove-315556f2b7dd9d1ebf7c09e9ed96fd20.png";